<div class="footer" [ngClass]="{'fixed-bottom': position === 'fixed-bottom'}">
  <div class="footer-content">
    <p
     [attr.aria-hidden]="!aria.tip"
     [attr.aria-label]="aria.tip | ariaLabel | translate"
     *ngIf="!!tip"
     class="footer-tip">
     <ion-text color="medium">{{tip|translate}}</ion-text></p>
    <ion-button
      *ngIf="secondaryButton && !secondaryButton.hidden"
      [attr.aria-label]="aria.secondaryButton | ariaLabel | translate"
      [appAriaButton]="aria.secondaryButton | ariaLabel | translate"
      fill="outline"
      color="primary"
      class="footer-secondary-action ion-no-margin"
      [disabled]="secondaryButtonDisabled"
      (click)="secondaryClick.next()">
      <ion-icon *ngIf="secondaryButton.icon" [slot]="!secondaryButton.text ? 'icon-only' : 'start'" [icon]="secondaryButton.icon"></ion-icon>
      {{secondaryButton.text | translate}}
    </ion-button>
    <span class="footer-spacer"></span>
    <ion-button *ngIf="primaryButton && !primaryButton.hidden"
      [attr.aria-label]="!primaryButtonDisabled ? (aria.primaryButton | ariaLabel | translate) : (aria.primaryButton + '_disabled' | ariaLabel | translate)"
      [appAriaButton]="!primaryButtonDisabled ? (aria.primaryButton | ariaLabel | translate) : (aria.primaryButton + '_disabled' | ariaLabel | translate)"
      color="accent"
      fill="solid"
      shape="round"
      class="footer-primary-action ion-no-margin"
      [ngClass]="{'button-circle': !!primaryButton.icon && !primaryButton.text}"
      [disabled]="primaryButtonDisabled"
      (click)="primaryClick.next()">
      <ion-icon aria-hidden="true" *ngIf="primaryButton.icon" [slot]="!primaryButton.text ? 'icon-only' : 'end'" [icon]="primaryButton.icon"></ion-icon>
      {{primaryButton.text ? (primaryButton.text | translate) : ''}}
    </ion-button>
  </div>
</div>